import { NSButton, NSLoadingScreen } from 'bricks';
import { useState } from 'react';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { useQuery } from '@tanstack/react-query';
import ProjectCard from './ProjectCard';
import ViewAllModal from './ViewAllModal';
import getCRMDealProjectsQueryOptions from './hooks/useGetCRMDealProjects';
import UpsertProjectsModal from './UpsertProjectsModal';

export interface IDealProjectsProps {
    organizationId: string;
    dealId: number;
}

const Projects = ({ organizationId, dealId }: IDealProjectsProps) => {
    const maxToDisplay = 3;
    const [showAll, setShowAll] = useState(false);
    const [showUpsertModal, setShowUpsertModal] = useState(false);

    const {
        data: projects,
        isSuccess,
    } = useQuery(getCRMDealProjectsQueryOptions(organizationId, dealId));

    return isSuccess ? (
        <div className="border-bottom p-2">
            <div className="d-flex justify-content-between align-items-center">
                <h5 className="text-white font-weight-bold my-1">
                    {`Projects (${projects.length})`}
                </h5>
                <NSButton
                    icon="plus"
                    text="Associate project"
                    className="text-primary p-0 d-block font-weight-normal heap-deal-activity-associate-project"
                    callback={() => setShowUpsertModal(!showUpsertModal)}
                />
            </div>
            {projects
                .slice(0, maxToDisplay)
                .map(project => <ProjectCard key={project.id} {...project} />)}

            {projects.length > maxToDisplay && (
                <NSButtonBase
                    callback={() => setShowAll(!showAll)}
                    text="View all associated projects"
                    icon={faChevronRight}
                    iconPosition="right"
                    className="font-weight-normal text-primary p-0 heap-deal-activity-view-associated-projects"
                />
            )}

            <ViewAllModal
                isOpen={showAll}
                toggle={() => setShowAll(!showAll)}
                title="View all associated companies"
            >
                { projects.map(project => <ProjectCard key={project.id} {...project} />) }
            </ViewAllModal>
            <UpsertProjectsModal
                isOpen={showUpsertModal}
                organizationId={organizationId}
                dealId={dealId}
                toggle={() => setShowUpsertModal(!showUpsertModal)}
                existingAssociations={projects}
            />
        </div>
    ) : (
        <NSLoadingScreen />
    );
};
export default Projects;
